import { render, staticRenderFns } from "./lot-group-item-proposal-overlay.vue?vue&type=template&id=d5639c60&scoped=true&lang=pug"
import script from "./lot-group-item-proposal-overlay.vue?vue&type=script&lang=js"
export * from "./lot-group-item-proposal-overlay.vue?vue&type=script&lang=js"
import style0 from "./lot-group-item-proposal-overlay.vue?vue&type=style&index=0&id=d5639c60&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5639c60",
  null
  
)

export default component.exports